import React from 'react';
import { Handle, Position } from 'reactflow';

class NodeVisibility extends React.Component {

  static getNode = (id, position) => {
    return {
      id: `n-${id}`,
      type: 'visibility',
      data: { id },
      position: position ? position : { x: 250, y: 100 }
    };
  }

  render() {
    return (
      <>
        <div className="dndnode input">
          Visibility : {this.props.data.label}
        </div>
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
      </>
    );
  }
}

export default NodeVisibility;
